exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".pay-buttons-container {\n  padding: 0 0 1.56rem;\n  margin: 0 0 1.56rem;\n  border-bottom: 1px solid rgba(26, 26, 26, 0.1); }\n  .pay-buttons-container > div {\n    margin: 0 1.3rem 0 0; }\n    .pay-buttons-container > div:last-child {\n      margin: 0; }\n  .pay-buttons-container .gpay-card-info-container {\n    min-width: 205px; }\n    .pay-buttons-container .gpay-card-info-container .gpay-card-info-placeholder-container {\n      width: 100%; }\n    .pay-buttons-container .gpay-card-info-container .gpay-card-info-iframe {\n      width: 100%;\n      margin-left: -13px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--1-oneOf-3-1!./node_modules/sass-loader/lib/loader.js!./src/components/PayButtons/PayButtons.scss
// module id = 410
// module chunks = 0